export const environment = {
  production: false,
  serverUrl: 'https://devback.progriscom.com',
  application: {},
  config: {
    api: false,
    url: './assets/params/json/crud/',
  },
};
